import React from "react";
import LegalPage from "@/components/legal/LegalPage";
import { aiSafetyContent } from "@/content/legal/ai-safety";

export default function AiSafety() {
  return (
    <LegalPage
      titleKey="public.aiSafety.title"
      updatedKey="public.lastUpdated"
      metaDescriptionKey="public.aiSafety.meta"
      sectionsByLang={aiSafetyContent}
      testId="page-ai-safety"
    />
  );
}
